/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationBellIcon16Solid = forwardRef('NotificationBellIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 1.25a5 5 0 0 0-5 5v3.032l-1.633 2.565A.75.75 0 0 0 2 13h12a.75.75 0 0 0 .633-1.153L13 9.282V6.25a5 5 0 0 0-5-5Z" }),
        React.createElement("path", { d: "M8 15.998A2.249 2.249 0 0 1 5.765 14h4.47A2.249 2.249 0 0 1 8 15.998Z" })));
});
